import React, { useContext } from "react";

import Selector from "components/selector/selector.component";

import { ClientsContext } from "src/contexts/clients.context";

import {
	ACTIVATION_TYPES,
	ARCHIVE_PERIODS,
	SAFE_LOCKING_PERIODS,
	SUBSCRIPTIONS,
} from "utils/lists.utils";

import "./plans-sub-category.style.scss";
import { getItemWhere } from "utils/array.utils";

const PLANS = [
	{
		key: "subscription",
		label: "Subscription",
		detail: "Client type will be determined based on the size and revenue of the company.",
		choices: SUBSCRIPTIONS,
	},
	{
		key: "archivePeriod",
		label: "Archive Period",
		detail:
			"The period which your accounts of ACHANTS, VENTES, and TVA will be examined by the client’s accountant.",
		choices: ARCHIVE_PERIODS,
	},
	{
		key: "safeLockingPeriod",
		label: "Safe Locking Period",
		detail:
			"The period which Client’s safe to be locked. The Client will get notifications about their upcoming safe locking deadlines.",
		choices: SAFE_LOCKING_PERIODS,
	},
	{
		key: "liveChat",
		label: "Live Chat",
		detail: "Direct contact between the Client and Accountant through the live chat.",
		choices: ACTIVATION_TYPES,
	},
	{
		key: "mobile",
		label: "Mobile App",
		detail:
			"Upload your documents just by scanning the pages using the METI Box mobile application. ",
		choices: ACTIVATION_TYPES,
	},
];

const PlansSubTab = ({ id }) => {
	const { clients, updateCompanyInfoPartially } = useContext(ClientsContext);

	const { companyType } = getItemWhere(clients, "id", id);

	let data;
	if (companyType === 0) {
		data = getItemWhere(clients, "id", id);
	} else if (companyType === 1) {
		data = getItemWhere(clients, "id", id).company;
	}

	const handleChange = (key, value) => {
		updateCompanyInfoPartially(id, key, value);
	};

	return (
		<div className="plans-sub-category-container padding-m--left">
			<p className="with-line w600 size400">Plans</p>
			{PLANS.map((plan, index) => {
				const { key, label, detail, choices } = plan;
				return (
					<div key={index} className="grid padding-m--block">
						<div>
							<p className="w600 size400 padding-s--bottom">{label}</p>
							<p className="w400 size300">{detail}</p>
						</div>
						<Selector
							onSelected={(value) => handleChange(key, choices.indexOf(value))}
							selected={choices[data[key]]}
							data={choices}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default PlansSubTab;
